import { Shop } from "../types/entity/shop";


export const markShopSortFunc = (shopMap: Map<number, Shop>) => {
  return (a: { storeId: number | string }, b: { storeId: number | string }) => {
    const getName = (id: number | string) => shopMap.get?.(Number(id))?.name || '';
    const nameA = getName(a.storeId).replace(/店$/, '');
    const nameB = getName(b.storeId).replace(/店$/, '');
    const numA = Number(nameA);
    const numB = Number(nameB);
    const isNumA = !isNaN(numA) && nameA.trim() !== '';
    const isNumB = !isNaN(numB) && nameB.trim() !== '';
    if (isNumA && isNumB) return numA - numB;
    if (isNumA) return -1;
    if (isNumB) return 1;
    return nameA.localeCompare(nameB);
  }
}

export interface SelectOption<V extends string | number = string | number> {
  label: string;
  value: V;
}

export interface BuildNumericMapOptionsParams {
  excludedValues?: number[];
}

/**
 * 将展示用的 Map（key 为数字，value 为文案）转换为可用于 Select 的 options 列表。
 */
export const buildNumericMapOptions = (
  labelMap: Record<number, string>,
  params?: BuildNumericMapOptionsParams,
): SelectOption<number>[] => {
  const excluded = new Set(params?.excludedValues || []);

  return Object.keys(labelMap)
    .map((k) => Number(k))
    .filter((n) => Number.isFinite(n))
    .filter((n) => !excluded.has(n))
    .sort((a, b) => a - b)
    .map((value) => ({ label: labelMap[value] || String(value), value }));
};
